import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	FormHelperText,
	NativeSelect,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	// Grid,
	// Select,
	Input,
	InputLabel,
	TableSortLabel,
	// MenuItem,
	Modal,
	Backdrop,
	//Fade,
	fade,
	Button,
	Grid,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone, FaceRounded } from "@material-ui/icons";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//cookies
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const getMuiTheme = () => createMuiTheme({
	overrides: {
	  MUIDataTableHeadCell: {
		root: {
		  '&:nth-child(1)': {
				width: 100
			  },	
		  '&:nth-child(2)': {
			width: 700
		  },
		  '&:nth-child(3)': {
			width: 180
		  }
		}
	  }
	}
  });

const GLTransactionHistory = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const [glAccount, setGlAccount] = useState([]);
	const [glAccFilter, setGlAccFilter] = useState('all');
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [grandTotal, setGrandTotal] = useState({ grand_total: 0, debit:0, credit: 0})
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [fourColumns, setFourColumns] = useState(false);
	const [ trigger,setTrigger] = useState(false);
	const classes = useStyles();
	//console.log(format(dateRange.endDate, "yyyy/MM/dd/"));


	// Data Fetching
	useEffect(() => {
		data();
	}, []);
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);

	//button search
	const filterData = async () => {
		if(trigger == true)
		{
			setFourColumns(true);
		}
		else
		{
			setFourColumns(false);
		}
		setDataLoaded(false);
		setGrandTotal({ grand_total: 0, debit:0, credit: 0}); //clear grandtotal every searcj
		await axios.get(process.env.REACT_APP_API_URL+'gl_tran_report', {
			params:{
				date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
				date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
				account_type_id: glAccFilter, //glAccFilter
				jc_u_idno: branchIdNo,  //branchIdNo
			}
		}).then((res=>{
			setPosts(res.data.data);
			if(res.data.data.length > 0){
				const grandTotal = res.data.data[res.data.data.length-1]; 
				if(grandTotal?.grand_total){
					res.data.data.pop(); //remove grand total
					setGrandTotal( prevState => ({ grand_total: grandTotal.grand_total, credit: grandTotal.grand_total_credit, debit: grandTotal.grand_total_debit, })) //store grandtotal in other state, and remove from result before displaying table
				}
			}
			setDataLoaded(true);
			// console.log(fourColumns);
		})).catch((error=>{
			// console.log(error.message)
		}))
	}
		
	const data = async () => {
		//get data for gl account dropdown
		const glRes = await axios.get(process.env.REACT_APP_API_URL+'gl_accounts_list',{
			params:{
                                branch:get_cookies("branchidno"),
                        }
		});
		// const allAccount = {
		//   id: "all",
		//   description: "All Accounts",
		//   branchidno: ""
		//   };
		// glRes.data.data.unshift(allAccount);
		// console.log(glRes);
		setGlAccount(glRes.data[0]);
		setDataLoaded(true);
		//remove me after doing revisions
	};
	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const selectAccountProps = {
		options: glAccount,
		getOptionLabel: (option) => option.description + ' - ' + option.branchidno
	};

	const columns = [
		{
			name: "acctid",
			label: "ID",
			options: {
				filter: false,
				// display: "excluded",
			},
		},
		{
			name: "expense_account",
			label: "Expense Account",
		},
		{
			name: "tamount",
			label:"Total Amount",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},
		

	];

	const columnsFour = [
		{
			name: "acctid",
			label: "ID",
			options: {
				filter: false,
				// display: "excluded",
			},
		},
		{
			name: "expense_account",
			label: "Expense Account",
		},
		{
			name: "tamount",
			label:"Total Amount",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},

		{
			name: "reference",
			label: "Action",
			options: {
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let glid =  posts[dataIndex].id;
						return (
							<Grid container spacing={1}>
								<Grid item xs={6}>
									<NavLink to={"/account/gl-transaction-history-view/"+glid}>
										<Button variant="contained" color="primary">
											View
										</Button>	
									   </NavLink> 
								</Grid>
							</Grid>
						);	
					}
				},
				download: false //exclude this column in csv export
		},
		

	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: false,  //add this
		print: false,
		viewColumns: false, //add this
		downloadOptions: {
			filename : 'GLTransactionHistoryReport.csv' //change filename of csv
		}
		// tableBodyHeight,
	};    
	const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/reports">
						<h2 className="header-title">Reports</h2>
					</NavLink>
					<Typography color="textPrimary">GL Transaction History Report</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
					<div style={style}>
						<Grid container spacing={1} >
							<Grid item xs={12} sm={5} lg={3}>
									<TextField
										id="outlined-basic"
										label="Select Date"
										variant="outlined"
										onFocus={() => setOpen(true)}
										autoComplete="off"
										fullWidth={true}
										value={`${format(
											dateRange.startDate,
											"MM/dd/yyyy"
										)} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
									/> 
									 <DateRangePicker
										open={open}
										toggle={toggle}
										onChange={(range) => dateRangeHandler(range)}
									 /> 
							</Grid>
							<Grid item xs={12} sm={5} lg={4} style ={{marginTop: "-16.5px"}} >
								<Autocomplete
                                        {...selectAccountProps}
                                        autoComplete
                                        includeInputInList
										className={classes.autoComplete}
                                        renderInput={(params) => (
                                            <TextField
												{...params}
                                                margin="normal"
                                                label="Select GL Account"
												variant="outlined"
												required="true"
                                            />
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												//prep_data.warehouse = JSON.stringify(newValue.id, null, ' ');
												//console.log(JSON.stringify(newValue.id, null, ' '));
												setGlAccFilter(newValue.id);

												if(newValue.id != "all")
												{
													setTrigger(true);
												}
												else
												{
													setTrigger(false);
												}
											}
											
										}}
                                    />

							</Grid>
							<Grid item xs={3} sm={2} lg={1}> 
								<Button style ={{marginTop: "10px"}} variant="contained" color="primary" onClick={() => {filterData()}}>Search</Button>
							</Grid>	
						</Grid>

						<Grid container spacing={1} direction="row" justifyContent="flex-start" alignItems="center" >
							
							
							<Grid item xs={12} sm={5} lg={4} >
								<TextField
								  //https://medium.com/the-clever-dev/the-complete-guide-to-material-ui-grid-align-items-f4b472dba03f
								  id="outlined"
								  type="text"
								  value={grandTotal.credit}
								  variant="outlined"
								  fullWidth={true}
								  label="Grand Credit"
        						  InputProps={{
        						    readOnly: true,
        						  }}
        						/>
								
							</Grid>	
							<Grid item xs={12} sm={5} lg={4}  >
								<TextField
								  //https://medium.com/the-clever-dev/the-complete-guide-to-material-ui-grid-align-items-f4b472dba03f
								  id="outlined"
								  type="text"
								  value={grandTotal.debit}
								  variant="outlined"
								  fullWidth={true}
								  label="Grand Debit"
        						  InputProps={{
        						    readOnly: true,
        						  }}
        						/>
								
							</Grid>	

							<Grid item xs={12} sm={5} lg={4}  >
								<TextField
								  //https://medium.com/the-clever-dev/the-complete-guide-to-material-ui-grid-align-items-f4b472dba03f
								  id="outlined"
								  type="text"
								  value={grandTotal.grand_total}
								  variant="outlined"
								  fullWidth={true}
								  label="Grand Total"
        						  InputProps={{
        						    readOnly: true,
        						  }}
        						/>
								
							</Grid>	
					</Grid>
						
					</div>  
				{!dataLoaded ? (
					<Preloader />
				) : (
					<MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
									<h3 className="header-title" style={{color:"#339933"}}>
										GL Transaction History
									</h3>
								</div>
							}
							data={posts}
							columns={fourColumns ? columnsFour : columns}
							options={options}
						/>
					</MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default GLTransactionHistory;
